<script>
  import Modal from "./Modal.svelte";
  let showModal;
  let isDisabled = false;

  let value = "The array.slice method can extract a slice from the beginning, middle, or end of an array for whatever purposes you require, without changing the original array.";
  let textDisplay = "";
  let wordArray = [""];
  let count = 0;
  let size = 1;
  let rate = 100;
  let intervalId;

  function toggleModal() {
    console.log("showModal", showModal);
    showModal = !showModal;
  }

  function closeModal() {
    showModal = false;
    stopText();
  }

  function startText() {
		textDisplay = '';
    wordArray = value.trim().split(" ");
    intervalId = setInterval(() => display(), 60000 / (rate/size));
    toggleModal();
  }

  function stopText() {
    clearInterval(intervalId);
    count = 0;
  }

  function display() {
    const words = wordArray.slice(count, count + size).join(" ");

    textDisplay = words;
    count += size;

    if (count >= wordArray.length) {
      clearInterval(intervalId);
      count = 0;
    }
  }
</script>

<style>
  main {
    height: 100%;
    max-width: 240px;
    margin: 0 auto;
    padding: 1em;
    text-align: center;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
	}

	h2 {
		margin-bottom: 2rem;
	}

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  textarea {
    height: 30vh;
    margin: 2rem auto;
		overflow: scroll;
		padding: 1rem;
    width: 80%;
  }

  .reader {
    font-size: 2.5rem;
    font-weight: bold;
    height: 100%;
    padding: 3rem;
  }

  .narrow {
    margin: auto auto 0;
    width: 10rem;
  }

  .mt-4 {
    margin-top: 4rem;
  }

  .flex {
		display: flex;
		justify-content: space-around;
	}
	.mx-auto {
		margin-left: auto;
		margin-right: auto;
	}
</style>

<main>

  <Modal
    {showModal}
    on:cancel={closeModal}
    on:close={closeModal}
    let:didAgree={isDisabled}>

    <div class="reader mt-4">{textDisplay}</div>

    <div class="narrow">
      <label for="size">Number of words: {size}</label>
      <input
        type="range"
        id="size"
        name="size"
        bind:value={size}
        min="1"
        max="5" />
    </div>
  </Modal>


	<h2>Speed Reader</h2>

  <div class="flex mx-auto">
    <div>
      <label for="size">Number of words: {size}</label>
      <input
        type="range"
        id="size"
        name="size"
        bind:value={size}
        min="1"
        max="5" />
    </div>

    <div>
      <label for="rate">Words per minute: {rate}</label>
      <input
        type="range"
        id="rate"
        name="rate"
        bind:value={rate}
        min="100"
        max="600" />
    </div>
  </div>

  <textarea name="text" class="text" bind:value autofocus />
  <br />
  <button on:click={startText}>start</button>
  <!-- <button on:click={stopText}>stop</button> -->

</main>
